import React from 'react'

export const ItemWarning: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <p className="text-xs text-brand-navy my-1 text-pretty">{children}</p>
)
